import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon } from '../SMPIcon';

type SMPArrowDownIconProps = {
  css?: CSS;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export const SMPArrowDownIcon = (props: SMPArrowDownIconProps): JSX.Element => {
  return (
    <SMPIcon css={{ ...props.css }} style={{ ...props.style, width: '24px', height: '16px' }} onClick={props.onClick}>
      <g transform='translate(-4.599 -4.969)'>
        <g transform='translate(10.599 10.969) rotate(0)'>
          <path
            d='M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z'
            transform='translate(0 0)'
            fill='currentColor'
          />
        </g>
      </g>
    </SMPIcon>
  );
};
